module.exports = __webpack_public_path__ + "img/FRONT SEAT.b18d21c7.svg";